module.exports = __webpack_public_path__ + "img/s1on.eec78c40.svg";